/**
 * Catalogue rules shared by web and mobile (the API applies the same ones: it has the last word).
 */

export interface InstallmentLike {
  amount_xaf?: number | null;
}

export interface PackageLike {
  status?: string;
  has_unpublished_changes?: boolean;
  blockers?: readonly unknown[];
}

/** Sum of the instalments; null while one amount is missing (nothing is guessed). */
export function installmentsTotal(installments: readonly InstallmentLike[]): number | null {
  if (!installments.length) return null;
  let total = 0;
  for (const { amount_xaf } of installments) {
    if (amount_xaf === null || amount_xaf === undefined) return null;
    total += amount_xaf;
  }
  return total;
}

export type PackageState = "published" | "changes" | "incomplete" | "draft" | "archived";

/** One badge per package, from the most to the least urgent for the owner. */
export function packageState(pkg: PackageLike): PackageState {
  if (pkg.status === "archived") return "archived";
  if (pkg.blockers?.length) return "incomplete";
  if (pkg.status === "published") return pkg.has_unpublished_changes ? "changes" : "published";
  return "draft";
}

/** "1 000 000" typed by a person → 1000000; empty → null; anything else → undefined (invalid). */
export function readAmount(text: string): number | null | undefined {
  const digits = text.replace(/[\s\u00A0\u202F.,]|fcfa|xaf/gi, "");
  if (!digits) return null;
  return /^\d+$/.test(digits) ? Number.parseInt(digits, 10) : undefined;
}
